import cx from 'classnames';
import moment from 'moment';
import { ChartActionsComponentProps, ChartMetaFormField, MarRecord } from 'models/ui';
import { DATE_FORMAT, DATE_FORMAT_MAR } from 'constants/app.constant';
import { chartHelper } from 'helpers';
import { Box, ChartActions, ChartPermission, ErrorCard, ErrorFormField, Sidebar } from 'components/common';
import { DOSE_MODE, FormField } from './constants';
import './mar.action.container.scss';

export interface MarHoldAndDiscontinueFormSidebarViewV2Props {
  selectedDosageRecord: MarRecord;
  doseFormMode: string;
  formFieldMap: Map<string, ChartMetaFormField>;
  formSubmittedCount: number;
  chartActionsProps: ChartActionsComponentProps;
  onCloseClick: Function;
  isAuthor: boolean;
  sidebarProps: Function;
  isShowEHRMar?: boolean;
}

const MarHoldAndDiscontinueFormSidebarViewV2 = (props: MarHoldAndDiscontinueFormSidebarViewV2Props) => {
  const { selectedDosageRecord, doseFormMode, formFieldMap, formSubmittedCount, chartActionsProps, onCloseClick, isAuthor, sidebarProps } = props;
  const drugName = selectedDosageRecord?.drugName;
  const route = selectedDosageRecord?.route;
  const dose = selectedDosageRecord?.dose;
  const frequency = selectedDosageRecord?.frequency;
  const specialInstructions = selectedDosageRecord?.specialInstructions;
  const isHold = doseFormMode === DOSE_MODE.HOLD;
  const isHoldOrDiscontinue = isHold || doseFormMode === DOSE_MODE.DISCONTINUE;
  const modeLabel = isHold ? 'Hold' : 'Discontinue';
  const modeFields = isHold
    ? { time: FormField.HOLD_TIME, firstInitial: FormField.HOLD_FIRST_INITIAL, comments: FormField.HOLD_COMMENTS, date: FormField.HOLD_DATE }
    : { time: FormField.DISCONTINUE_TIME, firstInitial: FormField.DISCONTINUE_FIRST_INITIAL, comments: FormField.DISCONTINUE_COMMENTS, date: FormField.DISCONTINUE_DATE };
  const authorTimeField = isHold ? FormField.HOLD_TIME_OFFSET : FormField.DISCONTINUE_TIME_OFFSET;
  const timeField = isAuthor ? formFieldMap.get(authorTimeField) : formFieldMap.get(modeFields.time);
  const dateValue = (props.isShowEHRMar ? moment(formFieldMap.get(modeFields.date)?.value, DATE_FORMAT).format(DATE_FORMAT_MAR) : formFieldMap.get(modeFields.date)?.value) || '';
  const dosageDateTime = `${moment(selectedDosageRecord?.dosageTimeTable).format(DATE_FORMAT_MAR)} | ${
    selectedDosageRecord?.dosageTimeSeparate || selectedDosageRecord?.orderStartTime
  }`;

  return (
    <Sidebar
      open={isHoldOrDiscontinue && !!selectedDosageRecord}
      onClose={() => chartHelper.handleCloseSidebar({ sidebarProps, onCloseClick })}
      sidebarProps={sidebarProps}
      className="mar-hold-discontinue-sidebar-box"
    >
      <Box mt3>
        <h2>{modeLabel}</h2>
      </Box>
      <div className="mar-actions-container">
        <h3 className="mar-actions-container__title">Order Item</h3>
        <div className="mar-actions-container__card">
          <div className="mar-actions-container__card-information">
            <h3>{drugName}</h3>
            {[route, dose, frequency].filter(Boolean).length > 0 && (
              <span className="u-els-bold u-els-color-n6 u-els-margin-right">{[route, dose, frequency].filter(Boolean).join(' · ')}</span>
            )}
            {specialInstructions && <div className="u-els-italic u-els-color-n7">{specialInstructions}</div>}
            <div className="u-els-color-n10">{`Dosage Date & Time: ${dosageDateTime}`}</div>
            <div className="u-els-bold u-els-color-n10">{`${modeLabel} Date: ${dateValue}`}</div>
          </div>
          <ErrorCard chartMetaFormFields={formFieldMap} showErrorCard={formSubmittedCount > 0} className="u-els-margin-bottom" />
          <Box className="mar-dosage">
            <ErrorFormField
              useDefaultMargin={false}
              formField={timeField}
              formSubmittedCount={formSubmittedCount}
              className={cx('u-els-margin-bottom-1x1o2 mar-dosage__time-field', { 'mar-dosage__input-offset-time': isAuthor })}
            />
            <ErrorFormField
              useDefaultMargin={false}
              formField={formFieldMap.get(modeFields.firstInitial)}
              formSubmittedCount={formSubmittedCount}
              className="u-els-margin-bottom-1x1o2"
              inputProps={{ placeholder: 'Enter' }}
            />
            <ErrorFormField
              formField={formFieldMap.get(modeFields.comments)}
              formSubmittedCount={formSubmittedCount}
              useDefaultMargin={false}
              className="u-els-margin-bottom-1x1o2"
            />
          </Box>
          <ChartPermission>{({ allowSaveFragment }) => allowSaveFragment && <ChartActions {...chartActionsProps} />}</ChartPermission>
        </div>
      </div>
    </Sidebar>
  );
};

MarHoldAndDiscontinueFormSidebarViewV2.displayName = 'MarHoldAndDiscontinueFormSidebarViewV2';
export default MarHoldAndDiscontinueFormSidebarViewV2;
